module.exports = __webpack_public_path__ + "img/250966d.png";